export default __webpack_public_path__ + "static/media/Lumera5.83dedf2b.png";